<template>
  <donut-form class="f-v f-ast" method="post" action="/shoutouts/deactivate">
    <donut-modal-sections-title category="warn" :title="`Are you sure you want to deactivate ${$i18n.t('shoutouts.feature')}?`" />
    <div class="t">
      <span>Donut will stop recognizing new {{ $i18n.t('shoutouts.shoutout', { count: 2 }) }} and no one will be able to redeem any </span>
      <span>{{ $i18n.t('shoutouts.reward', { count: 2 }) }}. You can reactivate {{ $i18n.t('shoutouts.feature') }} at any time.</span>
    </div>
    <donut-modal-sections-actions
      :is-form="true"
      :loading-on-save="true"
      :is-warning="true"
      button-text="Deactivate"
    />
  </donut-form>
</template>

<script setup>
  import { inject } from 'vue';

  const $i18n = inject('$i18n');
</script>
